/* import __COLOCATED_TEMPLATE__ from './stripe-elements-container.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

const STRIPE_OPTIONS = {
  fonts: [{
    cssSrc: 'https://fonts.googleapis.com/css?family=Source+Sans+Pro',
  }],
};

class StripeElementsContainer extends Component {
  @tracked elements = null;

  @service stripe;

  constructor() {
    super(...arguments);

    this.stripe.load().then(() => {
      if (!this.isDestroying) {
        this.elements = this.stripe.elements(STRIPE_OPTIONS);
      }
    });
  }
}

export default StripeElementsContainer;
